/**
 * officialDataService.js — Access official sports data via approved claim link.
 *
 * These endpoints return read-only official data (athletes, results, history)
 * from the swimming_results/swimmers tables through the approved claim link.
 *
 * Requires: an approved claim (club_official_claims.claim_status = 'approved')
 */
import { AZURE } from './api';

/**
 * Get the official club link status for an institution.
 * @param {number} institutionId
 * @returns {Promise<{linked: boolean, link: Object|null, stats: Object|null}>}
 */
export const getOfficialLinkStatus = async (institutionId) => {
  const { data } = await AZURE.get('/vukz/official-data/link-status', {
    params: { institution_id: institutionId },
  });
  return data.data;
};

/**
 * Get official athletes from the linked club.
 * @param {number} institutionId
 * @returns {Promise<{athletes: Array, total: number}>}
 */
export const getOfficialAthletes = async (institutionId) => {
  const { data } = await AZURE.get('/vukz/official-data/athletes', {
    params: { institution_id: institutionId },
  });
  return data.data;
};

/**
 * Get official results for a specific athlete.
 * @param {number} institutionId
 * @param {number} swimmerId
 * @returns {Promise<{results: Array, total: number}>}
 */
export const getAthleteOfficialResults = async (institutionId, swimmerId) => {
  const { data } = await AZURE.get(`/vukz/official-data/athletes/${swimmerId}/results`, {
    params: { institution_id: institutionId },
  });
  return data.data;
};

/**
 * Get competition history for a specific athlete.
 * @param {number} institutionId
 * @param {number} swimmerId
 * @returns {Promise<{competitions: Array, total: number}>}
 */
export const getAthleteCompetitionHistory = async (institutionId, swimmerId) => {
  const { data } = await AZURE.get(`/vukz/official-data/athletes/${swimmerId}/history`, {
    params: { institution_id: institutionId },
  });
  return data.data;
};
